import { amplitude } from "@eis-poc/lib-discover-medical-mfes";

export const EVENTS = {
  diCheckerPageLoaded: "Drug Interactions - viewed",
  diCheckerForInteractionsBtnClicked:
    "Drug Interactions - check_interactions_clicked",
  drugClicked: "Drug Guide - drug_clicked",
  drugBNFClicked: "Drug Guide - bnf_link_clicked",
  drugFilterClicked: "Drug Guide - filter_clicked",
  browseItemClicked: "Browse - item_clicked",
  browseTabClicked: "Browse - tab_clicked",
  browseFilterClicked: "Browse - filter_clicked",
  browseGroupExpanded: "Browse - group_expanded",
  browseTopicClicked: "Browse - topic_clicked",
  browseItemFollowedSuccess: "Browse - item_followed_success",
  browseItemFollowedFailed: "Browse - item_followed_failed",
  browseItemFollowedCanceled: "Browse - item_followed_canceled",
  browseItemUnfollowedSuccess: "Browse - item_unfollowed_success",
  browseItemUnfollowedFailed: "Browse - item_unfollowed_failed",
  browseChemoRegimensFilterUpdated: "Browse - chemo_regimen_filter_updated",
  browseChemoRegimensSortUpdated: "Browse - chemo_regimen_sort_updated",
  promoPlacardClicked: "Promo Placard - clicked",
};

export const logDrugClicked = ({ title, recordAn, filterInput }) => {
  amplitude.log(EVENTS.drugClicked, {
    title,
    record_an: recordAn,
    filter_input: filterInput,
  });
};

export const logDrugFilterClicked = ({ character }) => {
  amplitude.log(EVENTS.drugFilterClicked, {
    character,
  });
};

/* ************************** */
//  Browse BNF Links Amplitude Events
/* ************************** */

export const logDrugBNFClicked = (label) => {
  amplitude.log(EVENTS.drugBNFClicked, {
    navigate_to: label,
  });
};

/* ************************** */
//  Browse Amplitude Events
/* ************************** */

export const logBrowseItemClicked = (telemetryData) => {
  const { categoryId, isFollowing, browseType } = telemetryData;

  const eventProperties = {
    affordance: "main-menu",
    category_id: categoryId,
    is_followed: isFollowing,
    browse_type: browseType,
  };

  amplitude.log(EVENTS.browseItemClicked, { ...eventProperties });
};

export const logBrowseTabClicked = (telemetryData) => {
  const { navigateFrom, navigateTo } = telemetryData;
  const eventProperties = {
    navigate_to: navigateTo,
    navigate_from: navigateFrom,
  };

  amplitude.log(EVENTS.browseTabClicked, { ...eventProperties });
};

export const logBrowseFilterClicked = (telemetryData) => {
  const { affordance, characterFrom, characterTo } = telemetryData;
  const eventProperties = {
    affordance,
    character_from: characterFrom,
    character_to: characterTo,
  };

  amplitude.log(EVENTS.browseFilterClicked, { ...eventProperties });
};

export const logGenericBrowseTopicClicked = (telemetryData) => {
  const { affordance, title, characterFrom } = telemetryData;
  const eventProperties = {
    affordance,
    title,
    character_from: characterFrom,
  };
  amplitude.log(EVENTS.browseTopicClicked, { ...eventProperties });
};

export const logBrowseGroupExpanded = (telemetryData) => {
  const {
    categoryId,
    feedId,
    isFollowing,
    path,
    sectionTitle,
    browseType,
  } = telemetryData;

  const eventProperties = {
    path,
    section_title: sectionTitle || "",
    category_id: categoryId,
    feed_id: feedId,
    is_followed: isFollowing,
    browse_type: browseType,
  };
  amplitude.log(EVENTS.browseGroupExpanded, { ...eventProperties });
};

export const logBrowseTopicClicked = (telemetryData) => {
  const {
    categoryId,
    topicId,
    isFollowing,
    path,
    sectionTitle,
    browseType,
  } = telemetryData;

  const eventProperties = {
    path,
    section_title: sectionTitle || "",
    category_id: categoryId,
    topic_id: topicId,
    is_followed: isFollowing,
    browse_type: browseType,
  };
  amplitude.log(EVENTS.browseTopicClicked, { ...eventProperties });
};

export const logBrowseItemFollowedSuccess = (telemetryData) => {
  const { affordance, categoryId, followType, browseType } = telemetryData;

  const eventProperties = {
    affordance: affordance,
    category_id: categoryId,
    follow_type: followType,
    browse_type: browseType,
  };

  amplitude.log(EVENTS.browseItemFollowedSuccess, { ...eventProperties });
};

export const logBrowseItemFollowedFailed = (telemetryData) => {
  const { affordance, categoryId, followType, browseType } = telemetryData;

  const eventProperties = {
    affordance,
    category_id: categoryId,
    follow_type: followType,
    browse_type: browseType,
  };
  amplitude.log(EVENTS.browseItemFollowedFailed, { ...eventProperties });
};

export const logBrowseItemFollowedCanceled = (telemetryData) => {
  const { affordance, categoryId, browseType } = telemetryData;

  const eventProperties = {
    affordance,
    category_id: categoryId,
    browse_type: browseType,
  };
  amplitude.log(EVENTS.browseItemFollowedCanceled, { ...eventProperties });
};

export const logBrowseItemUnfollowedSuccess = (telemetryData) => {
  const { affordance, categoryId, browseType } = telemetryData;

  const eventProperties = {
    affordance,
    category_id: categoryId,
    browse_type: browseType,
  };

  amplitude.log(EVENTS.browseItemUnfollowedSuccess, { ...eventProperties });
};

export const logBrowseItemUnfollowedFailed = (telemetryData) => {
  const { affordance, categoryId, browseType } = telemetryData;

  const eventProperties = {
    affordance,
    category_id: categoryId,
    browse_type: browseType,
  };

  amplitude.log(EVENTS.browseItemUnfollowedFailed, { ...eventProperties });
};

export const logPromoPlacardClicked = (telemetryData) => {
  const { navigateFrom, navigateTo } = telemetryData;

  const eventProperties = {
    navigate_from: navigateFrom,
    navigate_to: navigateTo,
  };

  amplitude.log(EVENTS.promoPlacardClicked, { ...eventProperties });
};

/* ************************************ */
//  Drug interactions Amplitude Events
/* ************************************ */

export const logDICheckerPageLoaded = () => {
  amplitude.log(EVENTS.diCheckerPageLoaded, {});
};

export const logCheckerForInteractionsBtnClicked = (telemetryData) => {
  amplitude.log(EVENTS.diCheckerForInteractionsBtnClicked, {
    ...telemetryData,
  });
};

/* ************************************ */
//  ChemoRegimens Amplitude Events
/* ************************************ */
export const logBrowseChemoRegimenListItemClicked = (telemetryData) => {
  const { browseType, categoryId } = telemetryData;

  const eventProperties = {
    browse_type: browseType,
    category_id: categoryId,
  };

  amplitude.log(EVENTS.browseItemClicked, { ...eventProperties });
};

export const logBrowseChemoRegimenFilterUpdated = (telemetryData) => {
  const { value, filterType } = telemetryData;
  const eventProperties = { value, filter_type: filterType };

  amplitude.log(EVENTS.browseChemoRegimensFilterUpdated, {
    ...eventProperties,
  });
};

export const logBrowseChemoRegimenSortUpdated = (telemetryData) => {
  const { value } = telemetryData;
  amplitude.log(EVENTS.browseChemoRegimensSortUpdated, { value });
};

export const logBrowseChemoRegimenTopicClicked = (telemetryData) => {
  const { pubType, title, affordance, categoryId } = telemetryData;
  const eventProperties = {
    title,
    affordance,
    pubtype: pubType,
    category_id: categoryId,
  };

  amplitude.log(EVENTS.browseTopicClicked, { ...eventProperties });
};
